import * as apiCommon from '@/api/apiCommon'

// 计划查询
const apiName = '/webapi/plan'

// 获取理论计划
export function getTheoryPlan(data) {
	return apiCommon.save(apiName + '/getTheoryPlan', data)
}

//获取模拟机计划
export function getAircraftPlan(data) {
	return apiCommon.save(apiName + '/getAircraftPlan', data)
}

// 获取其他计划
export function getOtherPlan(data) {
	return apiCommon.save(apiName + '/getOtherPlan', data)
}